/**

* Copyright 2023 Manzia Inc (https://www.manzia.com)

Coded by www.manzia.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Actions
import { productActions } from "appSettings";

function ActionCell({ icons, payload }) {
  
  const navigate = useNavigate();

  function clickHandler(action) {
    
    switch(action) {
      case productActions.info:
        navigate(`/session/${payload.sessionId}`, { state: { lead: payload } });
        break;
      default:
        break;
    }
  }

  return (
      <MDBox mx={1} display="flex" alignItems="center" justifyContent="space-between">
        {icons.map(({ icon, color, action }) => 
          (
            <MDButton 
              key={icon} 
              sx={{ marginRight: "2px" }} 
              variant="outlined" 
              color={color} 
              size="medium" 
              iconOnly
              onClick={() => clickHandler(action)}
            >
              <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
            </MDButton>
          ))}
      </MDBox>
  );
}


// Typechecking props for the StatusCell
ActionCell.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    color: PropTypes.string,
    action: PropTypes.string,
  })).isRequired,
  payload: PropTypes.shape({
    sessionId: PropTypes.string
  }).isRequired
};

export default ActionCell;
